import { Culture, cultureLabels, VolunteersAboutRules } from "../../context/VolunteersAboutContext/constants";
import { LocalizedContentImageUpload, LocalizedContentTexts } from "../LocalizedContentFields";

export const getAboutSectionKey = (culture: Culture) => `about-${culture}`;

export const getAboutSectionLabel = (culture: Culture) => `Hakkında - ${cultureLabels[culture]}`;

export const VolunteersAboutFieldTexts: Record<Culture, LocalizedContentTexts> = {
	"tr-TR": {
		title: {
			label: "Başlık",
			placeholder: "Koç Gönüllüleri Nedir?",
		},
		description: {
			label: "Açıklama",
			placeholder: "Koç Gönüllüleri'ni tanıtan metin",
		},
		image: {
			label: "Resim",
		},
	},
	"en-US": {
		title: {
			label: "Title",
			placeholder: "What Is Koç Volunteers?",
		},
		description: {
			label: "Description",
			placeholder: "Text that introduces Koç Volunteers",
		},
		image: {
			label: "Image",
		},
	},
};

export const VolunteersAboutImageUpload: LocalizedContentImageUpload = {
	maxFileSize: String(VolunteersAboutRules.imageMaxFileSize),
	extensions: ["jpeg", "jpg", "png"],
	dimensions: [VolunteersAboutRules.imageDimension],
};
